import React from 'react';
import { Link } from "react-router-dom";
import TechnologySmallIcon from './technologySmallIcon.js'

import {RtDomainTechnology} from '../../../server/routes/route-types.js'

// interface TechnologyVersionData {
//     Technology: string;
//     TechnologyURL: string;
//     Version: string;
// }

interface TechnologyVersionRefProps {
    technology: RtDomainTechnology;
    technologyIcon: string;
}

export default function TechnologyVersionRef({ technology, technologyIcon }: TechnologyVersionRefProps) {

	return (   
        <>
        <TechnologySmallIcon
            technologyIcon={technologyIcon}
            technology={technology.Technology}
        />
        {' '}
        <Link 
            className="link-hover" 
            title={`${technology.Technology} v${technology.Version}`} 
            to={`/technology/${technology.TechnologyURL}/version/${technology.Version}/websites`}
        >
            {technology.Technology} v{technology.Version}
        </Link>          
        </>             
  
    );
}
